import useRestService from '../shared/rest-service';
import Tag from '../models/tag';
import { AssignedTag } from '../models/user';

/**
 * useTag
 * @function useTag - Custom hook for the tag models
 */
const useTag = () => {
  const { getAuth, postAuth, putAuth, deleteAuth } = useRestService();

  const fetchTags = (clientId: number): Promise<Array<Tag>> => {
    return getAuth(`api/${clientId}/tags`);
  };

  const fetchTag = (clientId: number, tagId: number): Promise<Tag> => {
    return getAuth(`api/${clientId}/tags/${tagId}`);
  };

  const createTag = (clientId: number, tagName: string) => {
    return postAuth(`api/${clientId}/tags`, tagName);
  };

  const deleteTag = (clientId: number, tagId: number) => {
    return deleteAuth(`api/${clientId}/tags/${tagId}`);
  };

  const updateTag = (clientId: number, tagId: number, data: Tag | AssignedTag) => {
    return putAuth(`api/${clientId}/tags/${tagId}`, data);
  };

  return {
    fetchTags,
    fetchTag,
    createTag,
    deleteTag,
    updateTag
  };
};

export default useTag;
